import RoutePath from '../../../../../constants/routePath';
import { reportsDictionary } from '../../dictionaries/ReportsDictionary';
import AppError from '../../../../../utils/appError';
import registerAction from '../../../../../action/registerErrorAction';
import { RoutingSessionStateModel } from '../../models/RoutingSessionStateModel';
import authenticationStore from 'store/authenticationStore';
import { getLoginUrl } from 'getUrls';

export class ReportsRouterHelper {
  
  static REPORTS_BASE_URL = RoutePath.ROUTE_2BAP_REPORTS_BASE;
  
  static REPORTS_LIST_URL = `${RoutePath.ROUTE_2BAP_REPORTS_LIST}`;
  static REPORTS_LIST_PATH = `${RoutePath.ROUTE_2BAP_REPORTS_BASE}/${RoutePath.ROUTE_2BAP_REPORTS_LIST}`;
  
  static REPORTS_GENERATION_URL = `${RoutePath.ROUTE_2BAP_REPORTS_GENERATION}`;
  static REPORTS_GENERATION_PATH = `${RoutePath.ROUTE_2BAP_REPORTS_BASE}/${RoutePath.ROUTE_2BAP_REPORTS_GENERATION}`;
  static REPORTS_TYPE_IDENTIFIER = 'reportType';
  
  static ROUTE_SESSION_STATE = null;
  static handleReportLayoutRouteEnter = () => {
    if (!ReportsRouterHelper.ROUTE_SESSION_STATE) {
      ReportsRouterHelper.ROUTE_SESSION_STATE = new RoutingSessionStateModel();
    }
  }
  static handleReportLayoutRouteLeave = () => {
    /** @type {RoutingSessionStateModel} */
    const state = ReportsRouterHelper.ROUTE_SESSION_STATE;
    if (!state) {
      return;
    }
    state.removeHistoryListener && state.removeHistoryListener();
    ReportsRouterHelper.ROUTE_SESSION_STATE = null;
  }
  
  static handleReportGenerationRouteEnter = async (nextState, replace, callback) => {
    const { query } = nextState.location;
    
    const reportType = query[ReportsRouterHelper.REPORTS_TYPE_IDENTIFIER];
    
    if (!authenticationStore.isLoggedIn()) {
      replace(getLoginUrl());
      callback();
      return;
    }
    
    const isValid = await reportsDictionary.validateReportType(reportType);
    
    if (!isValid) {
      const error = new AppError(AppError.CODE_NOT_FOUND);
      registerAction.registerError(error);
    }
    
    callback();
  }
  
}
